// removed by extract-text-webpack-plugin
module.exports = {"loadingWrap":"qempo_Loading_loadingWrap-2TLbQSQ","orange":"qempo_Loading_orange-1s5BRkV","lightBlue":"qempo_Loading_lightBlue-18eh-lt","white":"qempo_Loading_white-3uOrRYV","loadingCircle":"qempo_Loading_loadingCircle-1ylDK-e"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Loading/Loading.scss
// module id = 1262
// module chunks = 0